import React from 'react';
import { TextField } from '@mui/material';
import dialogStyles from '../dialog/GenericDialog.styles';

export default function ValidatedField({
  label,
  value = '',
  onChange,
  rules = [],
  externalError = '',
  type = 'text',
  placeholder,
  multiline = false,
  minRows,
  disabled = false,
  InputProps,
  InputLabelProps,
  fullWidth = true,
  size = 'small',
  sx,
  ...rest
}) {
  const hasValue = value !== '' && value != null;

  // Find the first failing rule (only when field is non-empty)
  const failingRule = hasValue ? rules.find((r) => !r.test(value)) : null;

  // External error (e.g. "code already exists") takes priority
  const errorMessage = externalError || (failingRule ? failingRule.message : '');
  const isError = Boolean(errorMessage);

  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      type={type}
      placeholder={placeholder}
      multiline={multiline}
      minRows={multiline ? (minRows ?? 3) : undefined}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      variant="outlined"
      InputProps={InputProps}
      InputLabelProps={InputLabelProps}
      error={isError}
      helperText={errorMessage}
      sx={{
        ...dialogStyles.outlinedField(hasValue),
        ...sx,
      }}
      {...rest}
    />
  );
}
